var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ant-icon',{style:(Object.assign({}, {fontSize: _vm.fontSize, verticalAlign: _vm.verticalAlign}, _vm.cusStyles)),attrs:{"type":_vm.type}})}
var staticRenderFns = []

export { render, staticRenderFns }